import { orgPermissions, RESOURCE_KEYS } from "utils/OrgPermissions";
import globalConstants from "constants/constants";
import { schedule_types_ids } from "features/Listings/constants/Listings.constants";

export const PAGE_STRINGS = {
  TITLE_OFFERINGS: "My Offerings",
  TITLE_CONTENT: "My Content",
  BTN_ADD_NEW: "Add New",
  BTN_CREATE_OFFERING: "Create an Offering",
  BTN_MANAGE_SLOTS: "Manage appointment slots",
  BTN_MANAGE_SLOTS_HEAD: "Manage Slots",
  API_TAB_ORDER: "host/ct/offering/view/tab/order/get",
};

export const LIVEOFFERINGS = "Live Offerings";
export const DRAFTOFFERINGS = "Draft Offerings";
export const PLANS = "Plans";
export const SOLDOUT = "In Waitlist";
export const PASTOFFERINGS = "Past Offerings";
export const LIVEEVENTS = "Live Events";
export const BATCHPROGRAMS = "Batch Programs";
export const COURSES = "Courses";
export const COMMUNITIES = "Communities";
export const MERCHANDISE = "Merchandise";
export const ONE_ON_ONE_CONSULTATIONS = "1-1 Consultations";
export const QUICKPAYMENTPAGES = "Quick Payment Pages";

export const SHARE = "Share";
export const EDIT = "Edit Offering";
export const DUPLICATEOFFERINGS = "Duplicate Offering";
export const MANAGEOFFERING = "Manage Offering";
export const ACCESSCOMMUNITY = "Access Community";
export const MANAGEBOOKINGS = "Manage Bookings";
export const DELETEOFFERINGS = "Delete Offering";
export const STOPSUBSCRIPTION = "Stop Subscription";
export const MANAGECOMMUNICATIONS = "Manage Communications";
export const MANAGEAVAILABILITY = "Manage Availability";
export const POSTBOOKINGURL = "Post Booking URL";
export const RENEWLINK = "Renew Link";
export const FEEDBACKS = "Feedback";
export const CREATESIMILAR = "Create Similar";
export const COMMENTS = "View/Post Comments";
export const DUPLICATEPLAN = "Duplicate Plan";
export const DELETEPLAN = "Delete Plan";
export const EDITPLAN = "Edit Plan";
export const MANAGEPLANBOOKINGS = "Manage Plan Booking";

export const CTA_MANAGE_SCHEDULE = "MANAGE_SCHEDULE";
export const CTA_ACCESS_COMMUNITY = "ACCESS_COMMUNITY";
export const CTA_COURSE_ANALYTICS = "COURSE_ANALYTICS";
export const CTA_SHARE_COMMUNITY = "SHARE_COMMUNITY";
export const CTA_SHARE_OFFERING = "SHARE_OFFERING";
export const CTA_MANAGE_OFFERING = "MANAGE_OFFERING";

export const getCustomCTA = (listing) => {
  if (!listing)
    return { label: "Manage Offering", action: CTA_MANAGE_OFFERING };

  switch (listing.type) {
    case schedule_types_ids.branded_community:
      return { label: "Access Community", action: CTA_ACCESS_COMMUNITY };

    case schedule_types_ids.content:
      return { label: "Course analytics", action: CTA_COURSE_ANALYTICS };

    case schedule_types_ids.whatsapp:
    case schedule_types_ids.telegram:
      return { label: "Share community", action: CTA_SHARE_COMMUNITY };

    case schedule_types_ids.no_schedule:
    case schedule_types_ids.merchandise:
      return { label: "Share offering", action: CTA_SHARE_OFFERING };

    case schedule_types_ids.group_class:
    case schedule_types_ids.rolling_class:
    case schedule_types_ids.one_on_one_class:
    case schedule_types_ids.one_on_one_appointment:
    case schedule_types_ids.webinar:
    case schedule_types_ids.workshop:
      return { label: "Manage schedule", action: CTA_MANAGE_SCHEDULE };

    default:
      return { label: "Manage Offering", action: CTA_MANAGE_OFFERING };
  }
};

export const plan_status_enums = {
  LIVE_PLAN: "LIVE_PLAN",
  DRAFT_PLAN: "DRAFT_PLAN",
  INACTIVE_PLAN: "INACTIVE_PLAN",
};

export const plan_status_labels = {
  [plan_status_enums.LIVE_PLAN]: "Active",
  [plan_status_enums.DRAFT_PLAN]: "Draft",
  [plan_status_enums.INACTIVE_PLAN]: "Expired",
};

export const planStatusLabelMapping = {
  1: plan_status_labels[plan_status_enums.LIVE_PLAN],
  2: plan_status_labels[plan_status_enums.INACTIVE_PLAN],
  3: plan_status_labels[plan_status_enums.DRAFT_PLAN],
};

export const SKU_STATUS_OPTIONS = [
  { id: 1, label: "Live", value: 1 },
  { id: 0, label: "Draft", value: 0 },
  { id: 2, label: "In Waitlist", value: 2 },
  { id: 3, label: "Past", value: 3 },
];

export const STATUS_OPTIONS_NON_PAST = [
  { id: 1, label: "Live", value: 1 },
  { id: 0, label: "Draft", value: 0 },
  { id: 2, label: "In Waitlist", value: 2 },
];

export const PLAN_STATUS_OPTIONS = [
  { id: 1, label: "Active", value: 1 },
  { id: 3, label: "Draft", value: 3 },
];

export const INFINITE_SCROLL_SENTINEL_HEIGHT = "20px";

export const constants = {
  tabLabels: [
    LIVEEVENTS,
    BATCHPROGRAMS,
    COURSES,
    COMMUNITIES,
    ONE_ON_ONE_CONSULTATIONS,
    MERCHANDISE,
    QUICKPAYMENTPAGES,
  ],

  layout_live: {
    shareAction: [SHARE],
    bottomBar: [MANAGEOFFERING, MANAGECOMMUNICATIONS, MANAGEBOOKINGS],
    customCTA: true,
    more: [
      EDIT,
      DUPLICATEOFFERINGS,
      ACCESSCOMMUNITY,
      COMMENTS,
      RENEWLINK,
      STOPSUBSCRIPTION,
      DELETEOFFERINGS,
    ],
    enableFilter: true,
    cardClick: true,
  },
  layout_draft: {
    bottomBar: [],
    customCTA: false,
    primaryAction: [DELETEOFFERINGS],
    action: [EDIT],
    enableFilter: true,
    cardClick: true,
  },
  layout_past: {
    primaryAction: [MANAGEOFFERING],
    // shareAction: [SHARE],
    // bottomBar: [MANAGEOFFERING, MANAGECOMMUNICATIONS, MANAGEBOOKINGS],
    // customCTA: false,
    action: [CREATESIMILAR],
    enableFilter: true,
  },
  layout_soldout: {
    shareAction: [SHARE],
    bottomBar: [MANAGEOFFERING, MANAGECOMMUNICATIONS, MANAGEBOOKINGS],
    customCTA: true,
    more: [EDIT, DUPLICATEOFFERINGS, ACCESSCOMMUNITY, DELETEOFFERINGS],
    enableFilter: true,
    cardClick: true,
  },
  layout_plan: {
    shareAction: [SHARE],
    primaryAction: [EDITPLAN],
    action: [MANAGEPLANBOOKINGS],
    more: [DUPLICATEPLAN, DELETEPLAN],
    enableFilter: false,
    cardClick: true,
  },
  layout_draft_plan: {
    action: [EDITPLAN],
    more: [DELETEPLAN],
    enableFilter: false,
    cardClick: true,
  },
  layout_inactive_plan: {
    action: [SHARE],
    more: [DELETEPLAN],
    enableFilter: false,
    cardClick: false,
  },

  permissions: () => ({
    sharePermision: orgPermissions.canShare(),
    canEdit: !orgPermissions.isTabHidden(
      RESOURCE_KEYS.SECTIONS.CREATE_EDIT_LISTINGS,
      RESOURCE_KEYS.SUBSECTIONS.CREATE_EDIT_LISTINGS.CREATE_EDIT_LISTINGS,
      RESOURCE_KEYS.TABS.CREATE_EDIT_LISTINGS.CREATE_EDIT_LISTINGS
        .MANAGE_APPOINTMENT
    ),
    canEditDuplicates: orgPermissions.canCreate(),
    canEditAvailability: orgPermissions.canEdit(),
    canEditPostBooking: orgPermissions.canEdit(),
    canDeleteRecord: orgPermissions.canDelete(),
    canFeedback: true,
  }),

  skuList: globalConstants.schedule_type.map((item) => ({
    id: item.id,
    label: item.name,
    value: item.id,
  })),

  lazyLoad: {
    desktop: {
      bottom: "0px",
      loadItems: 12,
    },
    mobile: {
      bottom: "100px",
      loadItems: 6,
    },
  },

  fallbackTitle: {
    live: "No Offerings yet",
    draft: "You have no drafts saved currently. Start drafting one.",
    plans: "No Plans Created Yet",
    soldOut: "No Waitlist offerings yet",
    past: "No Offerings yet",
    plan_titleSecondary:
      "As soon as we have a new plan, it will show up here. View the video to learn more.",
  },

  buttonText: {
    plans: "Create a Plan",
  },

  tabTag: {
    Plans: "New",
  },
  tabToolTip: {
    Plans:
      "Displays group of offerings as a drop down menu on the listing page.",
  },
  tabLabel: {
    live: 1,
    draft: 2,
    sold: 3,
    past: 4,
    plan: 5,
  },

  minPlanTitleLen: 3,
  postBookingUrlBtnMax: 35,
  offeringDescriptionOptions: [
    {
      label: "Save changes only for the selected offering",
      value: 0,
    },
    {
      label: "Copy the same description for all offerings selected and save",
      value: 1,
    },
  ],
  waitListInfoText:
    'When the offering is marked as "In Waitlist", the visitors of your website will see an option to join a waitlist. This can also be used to mark an offering as sold out.',
};

export const MY_OFFERINGS_LEARN_MORE_HREFS = {
  CREATE_EDIT_OFFERINGS:
    "https://support.exlyapp.com/support/solutions/84000147934",
  CREATE_PLANS:
    "https://support.exlyapp.com/support/solutions/articles/84000392225-how-to-bundle-offerings-in-plans-on-exly",
  MY_OFFERINGS_VIDEO: "https://www.youtube-nocookie.com/embed/oi301eoa-l0",
  PLANS_VIDEO: "https://www.youtube-nocookie.com/embed/6jfgHBUcgz4",
};

export const type_to_tab_label = {
  [schedule_types_ids.one_on_one_class]: LIVEEVENTS,
  [schedule_types_ids.group_class]: BATCHPROGRAMS,
  [schedule_types_ids.workshop]: LIVEEVENTS,
  [schedule_types_ids.no_schedule]: QUICKPAYMENTPAGES,
  [schedule_types_ids.content]: COURSES,
  [schedule_types_ids.rolling_class]: BATCHPROGRAMS,
  [schedule_types_ids.telegram]: COMMUNITIES,
  [schedule_types_ids.webinar]: LIVEEVENTS,
  [schedule_types_ids.whatsapp]: COMMUNITIES,
  [schedule_types_ids.branded_community]: COMMUNITIES,
  [schedule_types_ids.one_on_one_appointment]: ONE_ON_ONE_CONSULTATIONS,
  [schedule_types_ids.merchandise]: MERCHANDISE,
};

export const TAB_ORDER_QUERY_KEY = "tab-order";
